// import axios from 'axios'
import { initLanguage } from './language/initLanguage'

const locale = localStorage.getItem('currentLanguage') ?? 'en'

export const initBeforeAuth = (): Promise<[boolean]> => {
  return Promise.all([initLanguage(locale)])
}
